import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div>
      <div className="bg-gray-100">
        <div className="container px-4 py-8 mx-auto flex md:items-center lg:items-end md:flex-row md:flex-nowrap flex-wrap flex-col justify-between">
          <div className="w-64 flex-shrink-0 md:mx-0 mx-auto text-center md:text-left">
            <div className="sm:w-max flex sm:items-center">
              <div>
                <a
                  className="flex title-font font-medium items-center md:justify-start justify-center text-gray-900"
                  href="/"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 64 64"
                    fill="none"
                    className="w-7 h-7"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="32" cy="32" r="21.3333" fill="white" />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.52941 0C3.37103 0 0 3.37103 0 7.52941V56.4706C0 60.629 3.37103 64 7.52941 64H32C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0H7.52941ZM31.3172 23.377C34.0962 20.5435 38.51 20.0531 41.5069 22.6142C44.9398 25.5567 45.1033 30.7877 42.0518 33.9482L31.4807 44.8463C30.8268 45.5547 29.6825 45.5547 29.0286 44.8463L18.4575 33.9482C15.406 30.7877 15.5695 25.5567 19.0024 22.6142C21.9993 20.0531 26.4676 20.5435 29.1921 23.377L30.2819 24.4668L31.3172 23.377Z"
                      fill="url(#paint0_linear)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear"
                        x1="-5.90224e-07"
                        y1="-2.61818"
                        x2="52.6545"
                        y2="61.3818"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#3D98FF" />
                        <stop offset="1" stopColor="#330B66" />
                      </linearGradient>
                    </defs>
                  </svg>
                </a>
              </div>
              <div className="ml-4">
                <p className="text-sm text-gray-500 font-medium">
                  Learn from mentors in world class companies
                  <br />
                  with our global community.
                </p>
              </div>
            </div>
          </div>
          <div className="flex sm:flex row justify-center sm: mt-8">
            <a
              className="ml-3 text-white"
              href="https://twitter.com/devcolonyHQ"
            >
              <svg
                fill="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="w-7 h-7 bg-black rounded-full p-1.5"
                viewBox="0 0 24 24"
              >
                <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
              </svg>
            </a>
            <a
              className="ml-3 text-white"
              href="https://www.instagram.com/devcolonyhq/"
            >
              <svg
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="w-7 h-7 bg-black rounded-full p-1.5"
                viewBox="0 0 24 24"
              >
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
              </svg>
            </a>
            <a
              className="ml-3 text-white"
              href="https://www.linkedin.com/company/devcolony/"
            >
              <svg
                fill="currentColor"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0"
                className="w-7 h-7 bg-black rounded-full p-1.5"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="none"
                  d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"
                ></path>
                <circle cx="4" cy="4" r="2" stroke="none"></circle>
              </svg>
            </a>
          </div>
        </div>

        <div className="h-0.5 mx-20 bg-gray-300 rounded"></div>
        <div className="container mx-auto py-4 flex flex-wrap sm: justify-center sm:flex-row">
          <Link to="/mentors" className="flex flex-row justify-center">
            <h2 className="title-font font-medium text-gray-900 text-sm lg:mx-4">
              Find a mentor
            </h2>
          </Link>
          <Link
            to="/become-mentor"
            className="px-4 flex flex-row justify-center"
          >
            <h2 className="title-font font-medium text-gray-900 text-sm">
              Become a mentor
            </h2>
          </Link>

          <span className="inline-flex sm:ml-auto sm:mt-0 mt-2 justify-center sm:justify-start space-x-2">
            <div className="flex flex-row md:pl-80 sm-mb-10 md:mt-0 md:text-left truncate sm:space-x-4 space-x-reverse sm: mt-2">
              <a
                className="lg:w-1/4 md:w-1/2 w-full px-4"
                href="mailto:hellodevcolony@gmail.com"
              >
                <h2 className="title-font font-medium text-gray-900 text-sm">
                  join us
                </h2>
              </a>
              <div className="lg:w-1/4 md:w-1/2 w-full px-4">
                <Link to="/faq">
                  <h2 className="title-font font-medium text-gray-900 text-sm">
                    FAQs
                  </h2>
                </Link>
              </div>
              <a
                href="https://www.buymeacoffee.com/devcolony"
                target="_blank"
                rel="noreferrer"
                className="lg:w-1/4 md:w-1/2 w-full px-4"
              >
                <h2 className="title-font font-medium text-gray-900 text-sm">
                  support us
                </h2>
              </a>
            </div>
          </span>
        </div>
        <div className="bg-gray-100">
          <div className="container mx-auto flex flex-wrap flex-col sm:flex-row">
            <p className="text-gray-500 text-xs text-center sm:text-left lg:ml-4">
              Copyright {new Date().getFullYear()} - DevColony
            </p>
            <span className="inline-flex sm:ml-auto sm:mt-0 justify-center sm:justify-start space-x-2">
              <div className="flex flex-row md:pl-80 sm-mb-10 md:mt-0 md:text-left truncate sm:space-x-4 space-x-reverse sm: mt-4">
                <a href="mailto:hellodevcolony@gmail.com">
                  <div className="lg:w-1/4 md:w-1/2 w-full px-4">
                    <h2 className="title-font font-medium text-gray-500 text-xs underline">
                      Contact us
                    </h2>
                  </div>
                </a>
                <a href="https://devcolony.notion.site/Privacy-Policy-f084efab54a5428f960acefad35fcc05">
                  <div className="lg:w-1/4 md:w-1/2 w-full px-4">
                    <h2 className="title-font font-medium text-gray-500 text-xs underline">
                      Privacy Policy
                    </h2>
                  </div>
                </a>
                <a href="https://devcolony.notion.site/Terms-of-Use-cc89d10ca5414bf98ad238590f8d5097">
                  <div className="lg:w-1/4 md:w-1/2 w-full px-4 mb-8 sm:mb-10">
                    <h2 className="title-font font-medium text-gray-500 text-xs underline">
                      Terms of use
                    </h2>
                  </div>
                </a>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
